<article>
    <div class="carrotly" [ngClass]="{'sticky': stickyFlag}">
        <div class="sticky-position">
            <i data-aos="zoom-out-up" data-aos-duration="1000"></i>
        </div>
        <h1 id="intro">· 소개</h1>
        <em>캐럿틀리는 학습데이터 생성툴로서 인공지능을 학습 시키기 위한 기초 데이터를 가공하는 시스템입니다.
            기본적으로 Box, Line, Semantic, Point를 사용하여 라벨링을 하며, AI 알고리즘을 활용한 사물 인식을
            바탕으로 AI Detection/Semantic/Tracking과 같은 자동 어노테이션 기능, 3D Point
            Cloud를 Calibration하여 2D화면에 Overlay하는 기능, 3D 모드에서 라벨링하는 기능 등의 인공지능을
            활용하여 작업자의 시간을 단축시키면서도 정확도를 높일 수 있는 기능들이 포함되어 있습니다. </em>
    </div>
    <div id="full-page">
        <div class="function">
            <div class="section f01">
                <h1 class="last">· 주요기능</h1>
                <h4>1.프로젝트 타입에 맞는 학습데이터 가공</h4>
                <em> • 가공할 학습데이터의 활용에 맞는 타입을 선택하여 학습데이터를 가공하는 기능 <br> •
                    프로젝트 타입 : YOLO/Autonomous Drive/Ball Tracking
                </em>
                <table>
                    <tr class="type">
                        <th scope="row">Type</th>
                        <td><p class="yolo">YOLO</p></td>
                        <td><p class="drive">Autonomous Drive</p></td>
                        <td><p class="ball">Ball Tracking</p></td>
                    </tr>
                    <tr>
                        <th scope="row">업로드정보</th>
                        <td>영상정보</td>
                        <td>영상,센서정보</td>
                        <td>영상정보</td>
                    </tr>
                    <tr>
                        <th scope="row">Figure</th>
                        <td>Box only</td>
                        <td>Box, Line, Semantic, Point</td>
                        <td>Box only</td>
                    </tr>
                    <tr>
                        <th scope="row">Basic Workflow</th>
                        <td>Labelling</td>
                        <td>Labelling, QA</td>
                        <td>Labelling</td>
                    </tr>
                    <tr>
                        <th scope="row">Function</th>
                        <td>None</td>
                        <td>AI Detection <br> AI Semantic <br> AI
                            Tracking <br></td>
                        <td>Merge Frames (준비중)</td>
                    </tr>
                </table>
            </div>
            <div class="section f02">
                <h4>2. 2D Editor AI 기술을 활용한 자동 어노테이션 기능</h4>
                <em> <strong> • AI Detection </strong> <br> 인공지능을 기반으로
                    영상 정보의 자동자, 이륜차, 자전거, 보행자, 동물을 인식하여 자동 Bounding Box를 생성하는 기능
                </em> <img src="/assets/images/carrotly/detection.png">
            </div>
            <div class="section f03">
                <!-- <h4>2.2D Editor AI 기술을 활용한 자동 어노테이션 기능</h4> -->
                <em><strong> • AI Semantic</strong> <br> 인공지능을 기반으로
                    Bounding Box ROI 내의 Background와 Foreground를 구분하여 경계선을 Semantic으로
                    변환시키는 기능 </em> <img src="/assets/images/carrotly/detection02.png">
            </div>
            <div class="section f04">
                <!-- <h4>2.2D Editor AI 기술을 활용한 자동 어노테이션 기능</h4> -->
                <em> <strong> • AI Tracking</strong> <br> 인공지능을 기반으로
                    Bounding Box ROI의 대상 색상, 경계선을 추출한 후에 다음 프레임에 유사한 대상을 검색하여
                    Bounding Box를 생성하는 기능
                </em> <img src="/assets/images/carrotly/detection03.png">
            </div>
            <div class="section f05">
                <h4>3. 3D Point Cloud Calibration</h4>
                <em> • 영상 정보에 포함된 3D Point Cloud 영상 정보를 2D 화면 전체에 표시하는 기능 <br>
                    • 자율 주행용 2D 영상에 3D Point Cloud 오버레이(Overlay) 기술을 사용
                </em> <img src="/assets/images/carrotly/detection04.png">
            </div>
            <div class="section f06">
                <h4>4. 3D Editor 어노테이션</h4>
                <em> • 3D Point Cloud 영상 모델링과 라벨링 기술을 사용 <br> • Canvas에
                    위치한 3D Bounding Box를 Top/Front/Rear를 동시에 확인 가능
                </em> <img src="/assets/images/carrotly/detection05.png">
            </div>
        </div>
    </div>
</article>